// @ts-nocheck



import { createSlice } from '@reduxjs/toolkit';



import { maintenanceOperationGroupApi } from '../lib/api';

export const SET_MAINTENANCE_OPERATION_GROUPS =
'vehicles/maintenance-operation-group/set';

const initialState = null;

const maintenanceOperationGroupsSlice = createSlice({
  name: 'vehicles/maintenance-operation-group',
  initialState,
  reducers: {
    set: (
    state,
    { payload }) =>
    {
      return { ...payload };
    }
  }
});

export const maintenanceOperationGroupsActions =
maintenanceOperationGroupsSlice.actions;

export const fetchMaintenanceOperationGroups = () => async (
dispatch) =>
{
  const maintenanceOperationGroups = await maintenanceOperationGroupApi.fetchMaintenanceOperationGroups();
  dispatch(
    maintenanceOperationGroupsActions.set({ ...maintenanceOperationGroups })
  );
};

export default maintenanceOperationGroupsSlice.reducer;
